import dayjs from "dayjs";
import "dayjs/locale/de";
import "dayjs/locale/es";
import "dayjs/locale/fr";
import "dayjs/locale/it";
import "dayjs/locale/pl";
import "dayjs/locale/pt";
import "dayjs/locale/pt-br";

const DAYJS_LOCALE_MAP: Record<string, string> = {
  "de": "de",
  "es-419": "es",
  "es-ES": "es",
  "fr-FR": "fr",
  "it-IT": "it",
  "pl": "pl",
  "pt-BR": "pt-br",
  "pt-PT": "pt",
};

const parseDayJsLocaleFromLanguageCode = (language: string): string => {
  if (DAYJS_LOCALE_MAP[language]) {
    return DAYJS_LOCALE_MAP[language];
  }

  const loadedLocales = dayjs.Ls ?? {};
  const lowerLocale = language.toLowerCase();

  if (loadedLocales[lowerLocale]) return lowerLocale;

  const baseLanguage = language.split("-")[0].toLowerCase();
  if (loadedLocales[baseLanguage]) return baseLanguage;

  return "en";
};

export default parseDayJsLocaleFromLanguageCode;
